// Generated with SMAASearchImageData.generate().toCanvas().toDataURL(), not cropped, low dynamic range.
export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAhCAAAAABIXyLAAAAAOElEQVRIx2NgGAWjYBSMglEwEICREYRgFBZBqDCSLA2MGPUIVQETE9iNUAqLR5gIeoQKRgwXjwAAGn4AtaFeYLEAAAAASUVORK5CYII";



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/postprocessing/src/materials/images/smaa/searchImageDataURL.js
// module id = 174
// module chunks = 0